import type { ReactNode } from 'react';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { NethoneProvider } from '@sorare/core/src/contexts/nethone/Provider';
import { lazy } from '@sorare/core/src/lib/retry';

import type { Props as PaymentBoxProps } from '#src/components/buyActions/PaymentBox/index.tsx';
import type { Props as PaymentDialogProps } from '#src/components/buyActions/PaymentDialog/index.tsx';
import type { PaymentProps } from '#src/components/buyActions/PaymentProvider/index.tsx';

const PaymentProvider = lazy(
  async () => import('#src/components/buyActions/PaymentProvider/index.tsx'),
  'ContextProvider'
);
const PaymentBox = lazy(
  async () => import('#src/components/buyActions/PaymentBox/index.tsx'),
  'PaymentBox'
);
const PaymentDialog = lazy(
  async () => import('#src/components/buyActions/PaymentDialog/index.tsx'),
  'PaymentDialog'
);

type Props = {
  fallback?: ReactNode;
  paymentProps: PaymentProps;
  paymentBoxProps?: PaymentBoxProps;
  paymentDialogProps?: PaymentDialogProps;
};

export const LazyPaymentProvider = ({
  paymentProps,
  paymentBoxProps,
  paymentDialogProps,
  fallback = null,
}: Props) => {
  return (
    <Suspense fallback={fallback}>
      <NethoneProvider>
        <PaymentProvider {...paymentProps}>
          <ConditionalWrapper
            wrap={!!paymentDialogProps}
            Wrapper={PaymentDialog}
            props={paymentDialogProps}
          >
            <PaymentBox {...paymentBoxProps} />
          </ConditionalWrapper>
        </PaymentProvider>
      </NethoneProvider>
    </Suspense>
  );
};
